import styles from './refueling-stat-card.module.sass';
import classNames from 'classnames/bind';
import { GasStationFillIcon } from 'icons';
import Hr from 'componets/hr';

const cx = classNames.bind(styles);

function formatNumber(num) {
  return Intl.NumberFormat('zh-TW', {
    style: 'currency',
    currency: 'TWD',
    maximumFractionDigits: 0,
  }).format(num);
}

export const RefuelingStatCard = ({ className, title, lastMonthAmount, currentMonthAmount }) => {
  const contentList = [
    {
      label: '前月',
      amount: lastMonthAmount,
    },
    {
      label: '本月',
      amount: currentMonthAmount,
    },
  ];

  return (
    <div className={cx('refueling-stat-card', className)}>
      <div className={cx('refueling-stat-card-header')}>
        <GasStationFillIcon />
        <p>{title}</p>
      </div>
      <Hr />
      <div className={cx('refueling-stat-card-content')}>
        {contentList.map(item => (
          <div key={item.label} className={cx('refueling-stat-card-content-item')}>
            <p className={cx('refueling-stat-card-content-item-month')}>{item.label}</p>
            <p className={cx('refueling-stat-card-content-item-amount')}>{formatNumber(item.amount)}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
